/* eslint-disable prettier/prettier */
import { Select, Form, DatePicker, message } from "antd";
import moment from "moment";
import "./shared/styles.css";
import React, { useState, useEffect } from "react";

export const FormFechaHora = ({ personal, setPersonal, form }) => {
  const [schedule, setSchedule] = useState([]);
  // const [form] = Form.useForm();

  const handleChangeTime = (value) => {
    setPersonal((prev) => ({
      ...prev,
      timeValue: value,
    }));
  };

  const iniDaysValue = () => {
    return Array.isArray(personal?.daysValue)
      ? personal.daysValue.map((date) => moment(date, "YYYY-MM-DD"))
      : undefined;
  };

  const obtenerRangoHorarios = () => {
    const dia = moment().isoWeekday();
    let keyHorario;
    if (dia >= 1 && dia <= 5) keyHorario = "LUNES_VIERNES";
    else if (dia === 6) keyHorario = "SABADO";
    else keyHorario = "DOMINGO";

    const aperturaRaw = personal?.storeSchedule[keyHorario]?.HORA_APERTURA;
    const cierreRaw = personal?.storeSchedule[keyHorario]?.HORA_CIERRE;
    const apertura = moment(aperturaRaw ?? "01:00", "HH:mm");
    const cierre = moment(cierreRaw ?? "23:00", "HH:mm");
    const intervalos = [];
    const current = apertura.clone();

    while (current.isBefore(cierre)) {
      intervalos.push({
        value: current.format("HH:mm"),
        label: current.format("hh:mm a"),
      });
      current.add(30, "minutes");
    }
    return intervalos;
  };

  useEffect(() => {
    setSchedule(obtenerRangoHorarios());
  }, [schedule.length]);

  return (
    <>
      <div style={{ color: "#003a53", fontSize: 16, fontWeight: "bold", marginBottom: 5 }}>
        2. Formulario fecha y hora
      </div>
      <div style={{ fontSize: 16, borderBottom: "solid 1px grey", marginBottom: 15 }}>
        Seleccione los dias y el horario para generar solicitud
      </div>

      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        initialValues={{
          days: iniDaysValue,
          time: personal?.timeValue,
        }}
      >
        <Form.Item
          name="days"
          label="Seleccione los dÃ­as"
          rules={[{ required: true, message: "Por favor seleccione un rango de dÃ­as" }]}
        >
          <DatePicker.RangePicker
            rootClassName="join-inputs"
            style={{ width: "100%" }}
            format="DD-MM-YYYY"
            disabledDate={(current) => {
              if (!current) return false;

              const today = moment().startOf("day");
              const twoMonthsLater = moment().add(2, "months").endOf("day");

              return current.isBefore(today) || current.isAfter(twoMonthsLater);
            }}
            onChange={(dates) => {
              if (dates && dates.length === 2) {
                const [start, end] = dates;
                const diff = end.diff(start, "days");
                if (diff > 15) {
                  message.warning(
                    "El rango mÃ¡ximo permitido es de 15 dÃ­as. Por favor seleccione un nuevo rango."
                  );
                  form.setFieldsValue({ days: [start] });
                  setPersonal((prev) => ({
                    ...prev,
                    daysValue: [start.format("YYYY-MM-DD")],
                  }));
                } else {
                  const formattedDates = dates.map((date) => moment(date).format("YYYY-MM-DD"));
                  setPersonal((prev) => ({
                    ...prev,
                    daysValue: formattedDates,
                  }));
                }
              } else {
                setPersonal((prev) => ({
                  ...prev,
                  daysValue: undefined,
                }));
              }
            }}
          />
        </Form.Item>

        <Form.Item
          name="time"
          label="Seleccione horario"
          rules={[{ required: true, message: "Por favor seleccione un horario" }]}
        >
          <Select
            style={{ width: 120, textAlign: "left" }}
            dropdownStyle={{ textAlign: "left" }}
            onChange={handleChangeTime}
            placeholder="-- Seleccione --"
            options={schedule}
          />
        </Form.Item>
      </Form>
    </>
  );
};

